import { ActiveBadge, AppDialog, DetailField, DetailGrid } from "../../../components/ui";
import {
  POINT_REWARD_TYPE_LABELS,
  PointReward,
  formatPointRewardCost,
  formatPointRewardStock,
} from "../../../models/pointReward";
import { formatDateWithoutSeconds } from "../../../utils/functions/date";
import { PointRewardPreview } from "./PointRewardPreview";

export interface PointRewardDetailDialogProps {
  /** null = cerrado. */
  reward: PointReward | null;
  onHide: () => void;
}

/** Detalle de solo lectura de un premio (§6.3: un único botón "Cerrar"). */
export const PointRewardDetailDialog = ({ reward, onHide }: PointRewardDetailDialogProps) => (
  <AppDialog
    visible={reward !== null}
    onHide={onHide}
    header={reward ? reward.title : "Detalle del premio"}
    variant="detail"
    style={{ width: "min(92vw, 880px)" }}
  >
    {reward && (
      <div className="grid">
        <div className="col-12 md:col-7 flex flex-column" style={{ gap: "var(--space-18)" }}>
          <DetailGrid>
            <DetailField label="Tipo de premio">{POINT_REWARD_TYPE_LABELS[reward.rewardType]}</DetailField>
            <DetailField label="Costo">{formatPointRewardCost(reward.pointsCost)}</DetailField>
            <DetailField label="Stock">{formatPointRewardStock(reward.stock)}</DetailField>
            <DetailField label="Horas de expiración del QR">{reward.qrExpirationHours}</DetailField>
            <DetailField label="Partner">{reward.partnerName ?? "—"}</DetailField>
            <DetailField label="Ubicación del partner">{reward.partnerLocationInfo ?? "—"}</DetailField>
            <DetailField label="Estado">
              <ActiveBadge active={reward.active} />
            </DetailField>
            <DetailField label="Canjes pendientes">{reward.pendingRedemptionCount}</DetailField>
            <DetailField label="Última actualización">
              {reward.updatedAt ? formatDateWithoutSeconds(reward.updatedAt) : "—"}
            </DetailField>
            <DetailField label="Descripción" wide>
              {reward.description ?? "—"}
            </DetailField>
          </DetailGrid>
        </div>
        <div className="col-12 md:col-5">
          <PointRewardPreview
            title={reward.title}
            partnerName={reward.partnerName}
            pointsCost={reward.pointsCost}
            stock={reward.stock}
            imageUrl={reward.imageUrl}
            active={reward.active}
          />
        </div>
      </div>
    )}
  </AppDialog>
);
